import {
  SurveyTemplateWithQuestions,
  SurveyToCheckWithQuestionsAndResponses,
} from "..";
import { SurveyCheckResult } from "../../../types/syncCheckResult";
import { checkSurveyForDangerousChanges } from "./checkSurveyForDangerousChanges";

export const checkMultipleSurveysForDangerousChanges = (
  surveysToCheck: SurveyToCheckWithQuestionsAndResponses[],
  surveyTemplate: SurveyTemplateWithQuestions
): SurveyCheckResult[] => {
  const potentialDangerousSurveys: SurveyCheckResult[] = [];

  try {
    for (const surveyToCheck of surveysToCheck) {
      potentialDangerousSurveys.push(
        checkSurveyForDangerousChanges(
          surveyToCheck,
          surveyTemplate
        )
      );
    }
  } catch (err) {
    throw err;
  }

  return potentialDangerousSurveys;
};